import React, { useState } from 'react'
import './../../styles/components/dashboard/risk-score.css';

function RiskScore({ score, gradient }) {

    return (
        <div className="component risk-score">
            <div className={"score gradient-" + gradient}>
                <div className="circle">
                    <span className='number'>{score}</span>
                    <span className='text'>Your Score</span>
                </div>
            </div>
        </div>
    )
}

export default RiskScore